module.exports = __webpack_public_path__ + "img/aviation_mix4.5ad19e0f.jpg";